import { Box, Checkbox } from "@mui/material"
import { WarningOutlined } from "@mui-symbols-material/w300"
import type { CellContext, ColumnDef } from "@tanstack/react-table"
import type { ReactElement } from "react"

import type { Instruction } from "@/graphql/codegen/graphql"

export const columns: ColumnDef<Instruction>[] = [
  {
    accessorKey: "instructionId",
    id: "instructionId",
    header: "",
    cell: ({ row }: CellContext<Instruction, unknown>): ReactElement => {
      return (
        <Box className='space-x-5'>
          <Checkbox
            id={row.original.instructionId.toString()}
            checked={row.getIsSelected()}
            onChange={row.getToggleSelectedHandler()}
            disabled={!row.getCanSelect()}
          />
        </Box>
      )
    },
    size: 50,
  },
  {
    accessorKey: "name",
    header: "Name",
    enableSorting: true,
    size: 200,
  },
  {
    accessorKey: "description",
    header: "Instructions",
    enableSorting: false,
    size: 600,
  },
  {
    id: "isHazard",
    cell: ({ row }: CellContext<Instruction, unknown>): ReactElement => (
      <Box className='flex flex-col'>{Boolean(row.original.isHazard) && <WarningOutlined color='error' />}</Box>
    ),
    header: () => <WarningOutlined />,
    enableSorting: false,
  },
]
